import UserTable from "./components/UserTable";

const User: React.FC = () => {
  return (
    <div className="">
     <UserTable/>
    </div>
  );
};

export default User
